import { Pipe, PipeTransform } from '@angular/core';
import { OrderFinancialStatus } from '../models/order.model';

@Pipe({
    name: 'shopifyStatusColor',
    standalone: false
})
export class ShopifyStatusColorPipe implements PipeTransform {
  transform(value: string, shopifyStatusType: 'financial' = 'financial'): string {
    if (shopifyStatusType === 'financial') {
      return this.getFinancialStatusClass(value);
    }
    return 'NO SHOPIFY STATUS TYPE GIVEN';
  }

  getFinancialStatusClass(status: OrderFinancialStatus, prefix: string = 'chip--') {
    switch (status) {
      case 'VOIDED':
        return prefix + 'muted';
      case 'EXPIRED':
        return prefix + 'danger';
      case 'PARTIALLY_PAID':
      case 'PENDING':
        return prefix + 'warning';
      case 'PAID':
      case 'PARTIALLY_REFUNDED':
      case 'AUTHORIZED':
      case 'REFUNDED':
        return prefix + 'success';
      default:
        return '';
    }
  }
}
